import React from "react";
export default function TotalOrders() {
    const totalOrders = 12500;
    const leftCards = [
        {
            img: "https://cdn-icons-png.flaticon.com/512/4333/4333609.png",
            title: "Comfortable for daily wear",
            price: "₹999",
        },
        {
            img: "https://cdn-icons-png.flaticon.com/512/1040/1040230.png",
            title: "Premium fabric",
            price: "₹1,999",
        },
    ];
    const rightCards = [
        {
            img: "https://cdn-icons-png.flaticon.com/512/4140/4140048.png",
            title: "One shop for family",
            price: "₹1,299",
        },
        {
            img: "https://cdn-icons-png.flaticon.com/512/833/833472.png",
            title: "Made with love ❤️",
            price: "₹599",
        },
    ];
    return (
        <div className="section-header">
            <div>
                <h2>Why Choose Us?</h2>
            </div>
            <div className="total-orders-section">
                <div className="stats-layout">
                    <div className="side-grid">
                        {leftCards.map((card, index) => (
                            <div key={index} className="image-card">
                                <img src={card.img} alt={card.title} />
                                <h4>{card.title}</h4>
                                <p>{card.price}</p>
                                <button>View Details</button>
                            </div>
                        ))}
                    </div>
                    <div className="center-card">
                        <h2>Little Smiles Delivered So Far 🩷</h2>
                        <div className="orders-count">
                            {totalOrders.toLocaleString()}
                        </div>
                        <p>Trusted by thousands of happy customers</p>
                    </div>
                    <div className="side-grid">
                        {rightCards.map((card, index) => (
                            <div key={index} className="image-card">
                                <img src={card.img} alt={card.title} />
                                <h4>{card.title}</h4>
                                <p>{card.price}</p>
                                <button>View Details</button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}